import { faDollar } from '@fortawesome/pro-solid-svg-icons';
import {
  HeroMetric,
  HeroMetricProps,
} from '../../../../../../components/Summary/HeroMetric';
import { useCostPerVisit } from '@features/campaigns/subdomains/visitation/hooks/useCalculatedFields';

type CpvHeroMetricProps = {
  metricProps: Omit<HeroMetricProps, 'value'>;
} & Parameters<typeof useCostPerVisit>[0];

export const CpvHeroMetric = (props: CpvHeroMetricProps) => {
  const { value } = useCostPerVisit(props);

  return <HeroMetric {...props.metricProps} value={value} icon={faDollar} />;
};
